"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[5183],{

/***/ 5183:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ usageVideo)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
// components/usage-video.js


function usageVideo({ wrapper }) {
  const videoAPI = wrapper;
  const $section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest('.shopify-section');

  ; (function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:load', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).attr('id') === $section.attr('id')) {
        setTimeout(() => {
          playVideo()
        }, 300)
      }
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:select', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).attr('id') === $section.attr('id')) {
        setTimeout(() => {
          playVideo()
        }, 300)
      }
    })
  })();

  // * Event Listeners
  function playVideo() {
    console.log('playVideo')
    if (videoAPI.paused) {
      videoAPI.play()
    }
  }
}


/***/ })

}]);